"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleService = exports.LocaleServiceEventType = void 0;
const rxjs_1 = require("rxjs");
const LocalizedTextResolver_1 = require("./LocalizedTextResolver");
const LocalizedTextArrayResolver_1 = require("./LocalizedTextArrayResolver");
const LocaleSessionBuilder_1 = require("./LocaleSessionBuilder");
const LocaleUtil_1 = require("./LocaleUtil");
const UnitSystem_1 = require("./UnitSystem");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
var LocaleServiceEventType;
(function (LocaleServiceEventType) {
    LocaleServiceEventType["Init"] = "Init";
    LocaleServiceEventType["Update"] = "Update";
    LocaleServiceEventType["Reset"] = "Reset";
})(LocaleServiceEventType = exports.LocaleServiceEventType || (exports.LocaleServiceEventType = {}));
/**
 * The Locale Service provides features related to stateful i18n.
 *
 * It's purpose is to provide one single access point on stateful i18n data. Stateless i18n methods are implemented in the `LocaleUtil`.
 *
 * It has to be initialized with `LocaleServiceInitParams` which contains the `LocaleConfig` whereas it will create a private internal `LocaleSession`.
 * It provides public getters on base of the `LocaleSession` ensuring that only initialized properties will be retrieved.
 */
class LocaleService {
    /**
     * Initialization method of the Locale Service.
     *
     * It MUST be called before any other Locale Service method is used.
     *
     * It can only be initialized once since we store the localeSession in the quote and
     * we don't have a method yet to propagate any change to the quote.
     */
    static init(params) {
        if (this.hasBeenInitialized()) {
            throw new Error('LocaleService.init: has already been initialized');
        }
        this.localeServiceInitParams = Object.assign({}, params);
        this.localeSession = LocaleSessionBuilder_1.LocaleSessionBuilder.build(params);
        this.updateLocalizedTextResolvers(params);
        this.eventSubject.next({
            type: LocaleServiceEventType.Init,
        });
        return this;
    }
    /**
     * Updates the shopPriceCountry and the related currency
     */
    static update(params) {
        this.assertInitialization();
        if (!this.localeServiceInitParams) {
            throw new Error(`${this.className}.update() localeServiceInitParams is undefined`);
        }
        Object.assign(this.localeServiceInitParams, params);
        this.localeSession = LocaleSessionBuilder_1.LocaleSessionBuilder.build(this.localeServiceInitParams);
        this.updateLocalizedTextResolvers(params);
        this.eventSubject.next({
            type: LocaleServiceEventType.Update,
        });
        return this;
    }
    static updateLocalizedTextResolvers(params) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
        if (!this.localeSession) {
            throw new Error(`${this.className}.updateLocalizedTextResolvers() localeSession is undefined`);
        }
        this.userArticleTextResolver = new LocalizedTextResolver_1.LocalizedTextResolver(this.localeSession.userArticleLanguageTag, (_e = (_c = (_b = params.localeConfig) === null || _b === void 0 ? void 0 : _b.defaultArticleLanguageTags) !== null && _c !== void 0 ? _c : (_d = this.userArticleTextResolver) === null || _d === void 0 ? void 0 : _d.defaultLocales) !== null && _e !== void 0 ? _e : [], (_j = (_g = (_f = params.localeConfig) === null || _f === void 0 ? void 0 : _f.missingTranslationValue) !== null && _g !== void 0 ? _g : (_h = this.userArticleTextResolver) === null || _h === void 0 ? void 0 : _h.unresolvedLabel) !== null && _j !== void 0 ? _j : '');
        this.userArticleTextArrayResolver = new LocalizedTextArrayResolver_1.LocalizedTextArrayResolver(this.localeSession.userArticleLanguageTag, (_o = (_l = (_k = params.localeConfig) === null || _k === void 0 ? void 0 : _k.defaultArticleLanguageTags) !== null && _l !== void 0 ? _l : (_m = this.userArticleTextArrayResolver) === null || _m === void 0 ? void 0 : _m.defaultLocales) !== null && _o !== void 0 ? _o : [], (_s = (_q = (_p = params.localeConfig) === null || _p === void 0 ? void 0 : _p.missingTranslationValue) !== null && _q !== void 0 ? _q : (_r = this.userArticleTextArrayResolver) === null || _r === void 0 ? void 0 : _r.unresolvedLabel) !== null && _s !== void 0 ? _s : '');
        if (this.localeSession.iSalesArticleLanguageTag) {
            if (params.localeConfig || this.iSalesArticleTextResolver) {
                this.iSalesArticleTextResolver = new LocalizedTextResolver_1.LocalizedTextResolver(this.localeSession.iSalesArticleLanguageTag, (_w = (_u = (_t = params.localeConfig) === null || _t === void 0 ? void 0 : _t.defaultArticleLanguageTags) !== null && _u !== void 0 ? _u : (_v = this.iSalesArticleTextResolver) === null || _v === void 0 ? void 0 : _v.defaultLocales) !== null && _w !== void 0 ? _w : [], (_0 = (_y = (_x = params.localeConfig) === null || _x === void 0 ? void 0 : _x.missingTranslationValue) !== null && _y !== void 0 ? _y : (_z = this.iSalesArticleTextResolver) === null || _z === void 0 ? void 0 : _z.unresolvedLabel) !== null && _0 !== void 0 ? _0 : '');
            }
            if (params.localeConfig || this.iSalesArticleTextArrayResolver) {
                this.iSalesArticleTextArrayResolver = new LocalizedTextArrayResolver_1.LocalizedTextArrayResolver(this.localeSession.iSalesArticleLanguageTag, (_4 = (_2 = (_1 = params.localeConfig) === null || _1 === void 0 ? void 0 : _1.defaultArticleLanguageTags) !== null && _2 !== void 0 ? _2 : (_3 = this.iSalesArticleTextArrayResolver) === null || _3 === void 0 ? void 0 : _3.defaultLocales) !== null && _4 !== void 0 ? _4 : [], (_8 = (_6 = (_5 = params.localeConfig) === null || _5 === void 0 ? void 0 : _5.missingTranslationValue) !== null && _6 !== void 0 ? _6 : (_7 = this.iSalesArticleTextArrayResolver) === null || _7 === void 0 ? void 0 : _7.unresolvedLabel) !== null && _8 !== void 0 ? _8 : '');
            }
        }
    }
    /**
     * Resets the Locale Service to its initial state. Useful for testing.
     */
    static reset() {
        this.localeServiceInitParams = undefined;
        this.localeSession = undefined;
        this.userArticleTextResolver = undefined;
        this.userArticleTextArrayResolver = undefined;
        this.iSalesArticleTextResolver = undefined;
        this.iSalesArticleTextArrayResolver = undefined;
        this.eventSubject.next({
            type: LocaleServiceEventType.Reset,
        });
        return this;
    }
    /**
     * The Locale Service initialization parameters.
     */
    static getLocaleServiceInitParams() {
        this.assertInitialization();
        if (!this.localeServiceInitParams) {
            throw new Error(`${this.className}.getLocaleServiceInitParams() localeServiceInitParams is undefined`);
        }
        return this.localeServiceInitParams;
    }
    static getUserCadClickLanguageTag() {
        return this.getSessionPropertySafe('userCadClickLanguageTag');
    }
    static getShopPriceCountry() {
        return this.getSessionPropertySafe('shopPriceCountry');
    }
    static getArtNrCountry() {
        return this.getSessionPropertySafe('artNrCountry');
    }
    static getIaMontageCountry() {
        return this.getSessionPropertySafe('iaMontageCountry');
    }
    static isImperial() {
        return this.getUnitSystem() === UnitSystem_1.UnitSystem.imperial;
    }
    static isMetric() {
        return this.getUnitSystem() === UnitSystem_1.UnitSystem.metric;
    }
    /**
     * Defines which unit system (metric, imperial) should be used.
     */
    static getUnitSystem() {
        return this.getSessionPropertySafe('unitSystem');
    }
    /**
     * Retrieves the damId according to the current UnitSystem from a LocalizedText
     */
    static getLocalizedDamId(idObject) {
        if (!idObject)
            return undefined;
        return this.getUnitSystem() === UnitSystem_1.UnitSystem.metric ? idObject['de-DE'] : idObject['en-US'];
    }
    /**
     * Returns the localized series kuerzel (eg. DE: E61.52 vs. US: E61-52)
     */
    static getLocalizedSerieKuerzel(kuerzel) {
        return (kuerzel && this.getCountry(echain_shared_igus_fundamentals_1.Actor.UserPerson)) === 'US' ? kuerzel === null || kuerzel === void 0 ? void 0 : kuerzel.replace('.', '-') : kuerzel;
    }
    static getIgusDomain() {
        return this.getSessionPropertySafe('igusDomain');
    }
    //
    // Localized text resolvers
    //
    /**
     * Retrieve the correct article number based on the article number country of the Locale Service.
     * If no article number is found for the article number country, then undefined is returned.
     */
    static getArtNr(localizedArtNr) {
        return LocaleUtil_1.LocaleUtil.getArtNrWithFallback(localizedArtNr, this.getArtNrCountry());
    }
    /**
     * Retrieve the correct article number based on the article number country of the Locale Service.
     * If no article number is found for the article number country, then undefined is returned.
     */
    static getArtNrWithFallback(localizedArtNr) {
        var _b;
        if (this.hasBeenInitialized()) {
            return LocaleUtil_1.LocaleUtil.getArtNrWithFallback(localizedArtNr, (_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.artNrCountry);
        }
        return LocaleUtil_1.LocaleUtil.getArtNrWithFallback(localizedArtNr);
    }
    /**
     * Resolve the localized article text for the user.
     */
    static getUserArticleLocalizedText(localizedText) {
        this.assertInitialization();
        if (!this.userArticleTextResolver) {
            throw new Error(`${this.className}.getUserArticleLocalizedText() userArticleTextResolver is undefined`);
        }
        return this.userArticleTextResolver.resolve(localizedText);
    }
    /**
     * Returns a resolver that can be used to resolve a localized article text for the user.
     */
    static getUserArticleLocalizedTextResolver() {
        this.assertInitialization();
        if (!this.userArticleTextResolver) {
            throw new Error(`${this.className}.getUserArticleLocalizedTextResolver() userArticleTextResolver is undefined`);
        }
        return this.userArticleTextResolver;
    }
    /**
     * Resolve the localized article text array for the user.
     */
    static getUserArticleLocalizedTextArray(localizedTextArray) {
        this.assertInitialization();
        if (!this.userArticleTextArrayResolver) {
            throw new Error(`${this.className}.getUserArticleLocalizedTextArray() userArticleTextArrayResolver is undefined`);
        }
        return this.userArticleTextArrayResolver.resolve(localizedTextArray);
    }
    /**
     * Returns a resolver that can be used to resolve a localized article text for the user.
     */
    static getUserArticleLocalizedTextArrayResolver() {
        this.assertInitialization();
        if (!this.userArticleTextArrayResolver) {
            throw new Error(`${this.className}.getUserArticleLocalizedTextArrayResolver() userArticleTextArrayResolver is undefined`);
        }
        return this.userArticleTextArrayResolver;
    }
    /**
     * Resolve the localized article text for iSales export.
     */
    static getISalesArticleLocalizedText(localizedText) {
        return this.getISalesArticleLocalizedTextResolver().resolve(localizedText);
    }
    /**
     * Returns a resolver that can be used to resolve a localized article text for iSales export.
     */
    static getISalesArticleLocalizedTextResolver() {
        this.assertInitialization();
        if (!this.iSalesArticleTextResolver) {
            throw new Error(`${this.className}.getISalesArticleLocalizedTextResolver: iSalesArticleTextResolver has not been initialized`);
        }
        return this.iSalesArticleTextResolver;
    }
    /**
     * Resolve the localized article text array for iSales export.
     */
    static getISalesArticleLocalizedTextArray(localizedTextArray) {
        return this.getISalesArticleLocalizedTextArrayResolver().resolve(localizedTextArray);
    }
    /**
     * Returns a resolver that can be used to resolve a localized article text array for iSales export.
     */
    static getISalesArticleLocalizedTextArrayResolver() {
        this.assertInitialization();
        if (!this.iSalesArticleTextArrayResolver) {
            throw new Error(`${this.className}.getISalesArticleLocalizedTextArrayResolver: iSalesArticleTextArrayResolver has not been initialized`);
        }
        return this.iSalesArticleTextArrayResolver;
    }
    //
    // Actor-based getters
    //
    /**
     * Retrieves a language tag in priority by given order of actors.
     * The allowed actors represent all supported actors for this method.
     *
     * @deprecated use getLanguageTag instead. You should always know your target actor!
     */
    static getLanguageTagNotKnowingMyActor(actor1, actor2, ...furtherActors) {
        this.assertInitialization();
        const actors = [actor1, actor2].concat(furtherActors);
        for (const actor of actors) {
            const tag = this._getLanguageTag(actor);
            if (tag) {
                return tag;
            }
        }
        throw new Error(`${this.className}.getLanguageTagNotKnowingMyActor: could not determine a language of actors ${actors.join(',')}`);
    }
    /**
     * Retrieves a language tag of an actor.
     */
    static getLanguageTag(actor) {
        const tag = this._getLanguageTag(actor);
        if (tag) {
            return tag;
        }
        throw new Error(`${this.className}.getLanguageTag: could not determine a language of actor ${actor}`);
    }
    static _getLanguageTag(actor) {
        var _b, _c, _d;
        this.assertInitialization();
        switch (actor) {
            case echain_shared_igus_fundamentals_1.Actor.UserPerson:
                return (_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.userLanguageTag;
            case echain_shared_igus_fundamentals_1.Actor.ISalesSystem:
                return (_c = this.localeSession) === null || _c === void 0 ? void 0 : _c.iSalesLanguageTag;
            case echain_shared_igus_fundamentals_1.Actor.ShopSystem:
                return (_d = this.localeSession) === null || _d === void 0 ? void 0 : _d.shopLanguageTag;
            default:
                throw new Error(`${this.className}._getLanguageTag: unknown actor ${actor}`);
        }
    }
    /**
     * Retrieves a language subtag of an actor.
     */
    static getLanguageSubtag(actor) {
        const tag = this._getLanguageSubtag(actor);
        if (tag) {
            return tag;
        }
        throw new Error(`${this.className}.getLanguageSubtag: could not determine a language of actor ${actor}`);
    }
    static _getLanguageSubtag(actor) {
        var _b;
        this.assertInitialization();
        switch (actor) {
            case echain_shared_igus_fundamentals_1.Actor.ShopSystem:
                return (_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.shopLanguageSubtag;
            default:
                throw new Error(`${this.className}._getLanguageSubtag: unknown actor ${actor}`);
        }
    }
    /**
     * Retrieves an article language tag of an actor.
     */
    static getArticleLanguageTag(actor) {
        const tag = this._getArticleLanguageTag(actor);
        if (tag) {
            return tag;
        }
        throw new Error(`${this.className}.getArticleLanguageTag: could not determine a language of actor ${actor}`);
    }
    static _getArticleLanguageTag(actor) {
        var _b, _c;
        this.assertInitialization();
        switch (actor) {
            case echain_shared_igus_fundamentals_1.Actor.UserPerson:
                return (_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.userArticleLanguageTag;
            case echain_shared_igus_fundamentals_1.Actor.ISalesSystem:
                return (_c = this.localeSession) === null || _c === void 0 ? void 0 : _c.iSalesArticleLanguageTag;
            default:
                throw new Error(`${this.className}._getArticleLanguageTag: unknown actor ${actor}`);
        }
    }
    /**
     * Retrieves a country of an actor.
     */
    static getCountry(actor) {
        const tag = this._getCountry(actor);
        if (tag) {
            return tag;
        }
        throw new Error(`${this.className}.getCountry: could not determine a country of actor ${actor}`);
    }
    static _getCountry(actor) {
        var _b, _c, _d;
        this.assertInitialization();
        switch (actor) {
            case echain_shared_igus_fundamentals_1.Actor.UserPerson:
                return (_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.userCountry;
            case echain_shared_igus_fundamentals_1.Actor.ISalesSystem:
                return (_c = this.localeSession) === null || _c === void 0 ? void 0 : _c.iSalesCountry;
            case echain_shared_igus_fundamentals_1.Actor.ShopSystem:
                return (_d = this.localeSession) === null || _d === void 0 ? void 0 : _d.shopCountry;
            default:
                throw new Error(`${this.className}._getCountry: unknown actor ${actor}`);
        }
    }
    /**
     * Retrieves a currency of an actor.
     */
    static getCurrency(actor) {
        const tag = this._getCurrency(actor);
        if (tag) {
            return tag;
        }
        throw new Error(`${this.className}.getCurrency: could not determine a currency of actor ${actor}`);
    }
    static _getCurrency(actor) {
        var _b, _c;
        this.assertInitialization();
        switch (actor) {
            case echain_shared_igus_fundamentals_1.Actor.ISalesSystem:
                return (_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.iSalesCurrency;
            case echain_shared_igus_fundamentals_1.Actor.ShopSystem:
                return (_c = this.localeSession) === null || _c === void 0 ? void 0 : _c.shopCurrency;
            default:
                throw new Error(`${this.className}._getCurrency: unknown actor ${actor}`);
        }
    }
    /**
     * Retrieves a LocalizedTextResolver in priority by given order of actors.
     *
     * @deprecated use getArticleLocalizedTextResolver instead. You should always know your target actor!
     */
    static getArticleLocalizedTextResolverNotKnowingMyActor(actor1, actor2, ...furtherActors) {
        this.assertInitialization();
        const actors = [actor1, actor2].concat(furtherActors);
        for (const actor of actors) {
            const localizedTextResolver = this._getArticleLocalizedTextResolver(actor);
            if (localizedTextResolver) {
                return localizedTextResolver;
            }
        }
        throw new Error(`${this.className}.getArticleLocalizedTextResolverNotKnowingMyActor: could not determine a LocalizedTextResolver of actors ${actors.join(',')}`);
    }
    /**
     * Retrieves a LocalizedTextResolver for a given actor.
     */
    static getArticleLocalizedTextResolver(actor) {
        this.assertInitialization();
        const localizedTextResolver = this._getArticleLocalizedTextResolver(actor);
        if (localizedTextResolver) {
            return localizedTextResolver;
        }
        throw new Error(`${this.className}.getArticleLocalizedTextResolver: could not determine a LocalizedTextResolver of actor ${actor}`);
    }
    static _getArticleLocalizedTextResolver(actor) {
        switch (actor) {
            case echain_shared_igus_fundamentals_1.Actor.UserPerson:
                return this.userArticleTextResolver;
            case echain_shared_igus_fundamentals_1.Actor.ISalesSystem:
                return this.iSalesArticleTextResolver;
            default:
                throw new Error(`${this.className}._getArticleLocalizedTextResolver: unknown actor ${actor}`);
        }
    }
    /**
     * Retrieves a LocalizedTextArrayResolver for a given actor.
     */
    static getArticleLocalizedTextArrayResolver(actor) {
        this.assertInitialization();
        if (!this.userArticleTextArrayResolver) {
            throw new Error(`${this.className}.getArticleLocalizedTextArrayResolver(): userArticleTextArrayResolver is undefined`);
        }
        switch (actor) {
            case echain_shared_igus_fundamentals_1.Actor.UserPerson:
                return this.userArticleTextArrayResolver;
            case echain_shared_igus_fundamentals_1.Actor.ISalesSystem:
                if (this.iSalesArticleTextArrayResolver) {
                    return this.iSalesArticleTextArrayResolver;
                }
                break;
            default:
                throw new Error(`${this.className}.getArticleLocalizedTextArrayResolver: unknown actor ${actor}`);
        }
        throw new Error(`${this.className}.getArticleLocalizedTextArrayResolver: could not determine a LocalizedTextArrayResolver of actor ${actor}`);
    }
    //
    // Helper
    //
    /**
     * Default value if no translation value is found.
     */
    static getMissingTranslationValue() {
        this.assertInitialization();
        return this.getLocaleServiceInitParams().localeConfig.missingTranslationValue;
    }
    static isChinaShopPriceSession() {
        var _b, _c, _d;
        return (((_c = (_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.shopPriceCountry) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'CN' ||
            ((_d = this.localeSession) === null || _d === void 0 ? void 0 : _d.shopCountry.toUpperCase()) === 'CN');
    }
    /**
     * Returns true if the US article numbers should be used.
     */
    static isUsArtNr() {
        return LocaleUtil_1.LocaleUtil.isUsArtNr(this.getArtNrCountry());
    }
    /**
     * Returns true if the international article numbers should be used.
     */
    static isInternationalArtNr() {
        return LocaleUtil_1.LocaleUtil.isInternationalArtNr(this.getArtNrCountry());
    }
    /**
     * Retrieves a localized ArtNr separator.
     *
     * for US Countries(US, MX, CA): -
     * for all others: .
     */
    static getArtNrSeparator() {
        return LocaleUtil_1.LocaleUtil.getArtNrSeparator(this.getArtNrCountry());
    }
    /** Retrieves whether the LocaleService has been initialized and thus can be used. */
    static hasBeenInitialized() {
        return Boolean(this.localeSession);
    }
    static hasShopPriceCountry() {
        var _b;
        this.assertInitialization();
        return Boolean((_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.shopPriceCountry);
    }
    static hasShopCurrency() {
        var _b;
        this.assertInitialization();
        return Boolean((_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.shopCurrency);
    }
    static hasISalesLanguageTag() {
        var _b;
        this.assertInitialization();
        return Boolean((_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.iSalesLanguageTag);
    }
    static hasISalesCountry() {
        var _b;
        this.assertInitialization();
        return Boolean((_b = this.localeSession) === null || _b === void 0 ? void 0 : _b.iSalesCountry);
    }
    static getSessionPropertySafe(prop) {
        var _b;
        this.assertInitialization();
        if (((_b = this.localeSession) === null || _b === void 0 ? void 0 : _b[prop]) == null) {
            throw new Error(`${this.className}.getSessionPropertySafe: ${prop} is nully`);
        }
        return this.localeSession[prop];
    }
    /**
     * Helper method that ensures that the Locale Service is correctly initialized.
     */
    static assertInitialization() {
        if (!this.hasBeenInitialized())
            throw new Error('LocaleService: not initialized');
    }
}
exports.LocaleService = LocaleService;
_a = LocaleService;
LocaleService.className = 'LocaleService';
LocaleService.eventSubject = new rxjs_1.ReplaySubject(1);
/**
 * Stay up-to-date on the LocaleService's state
 * Replays the last (1) event.
 */
LocaleService.event$ = _a.eventSubject.asObservable();
//# sourceMappingURL=LocaleService.js.map